import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Agent } from '@/graphql/codegen/generated/graphql';
import { IncrediCheckbox } from 'incredi-ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentsTableCheckboxCell',
  props: {
    agentMetadata: null,
    modelValue: { type: [Boolean, null] }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:modelValue', value: boolean | null): void }), expose: any, slots: any, attrs: any }) {



// eslint-disable-next-line no-unused-vars


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IncrediCheckbox), {
    class: "agents-table-checkbox-cell flex items-center pl-2 w-full h-full",
    design: "primary-black",
    "model-value": __props.modelValue,
    selected: !!__props.modelValue,
    offline: __props.agentMetadata?.isOffline,
    "duplicate-license": __props.agentMetadata?.isDuplicateLicense,
    "incompatible-version": __props.agentMetadata?.isIncompatibleVersion,
    "in-progress": __props.agentMetadata?.isInProgress,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = newValue => emit('update:modelValue', newValue))
  }, null, 8, ["model-value", "selected", "offline", "duplicate-license", "incompatible-version", "in-progress"]))
}
}

})